import React from "react";
import { useTranslation } from "react-i18next";

const FullScreenPopup = ({ status, text, buttonText, onClose }) => {
  const { t } = useTranslation();
  // Функція повертає класи для рамки залежно від статусу
  const getStatusClasses = (status) => {
    switch (status) {
      case "success":
        return "text-green-500";
      case "warning":
        return "text-yellow-500";
      case "error":
        return "text-red-500";
      default:
        return "text-gray-500";
    }
  };

  return (
    <div className="fixed inset-0 flex flex-col bg-gray-900 text-white z-50 p-4">
      {/* Центральна зона з картинкою й текстом */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <img
          src={`/${status}-alert.webp`}
          alt=""
          className="w-3/4 xl:w-64 aspect-square"
        />
        <p className={`text-lg mt-4 ${getStatusClasses(status)}`}>{t(`alert.${text}`)}</p>
      </div>

      {/* Кнопка внизу на всю ширину */}
      {buttonText && (
        <button
          onClick={onClose}
          className="w-full text-lg py-2 bg-slate-950 text-white rounded-xl mt-4"
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default FullScreenPopup;
